// Card-capture popup for PayU tokenization (CREATE_TOKEN) + first charge (SUBMIT_TRANSACTION).
// The form does a real browser submit to PayuController#create_token, which redirects
// to subscription_success_path/subscription_error_path (same pattern as Izipay's
// retrieve_subscription_intent) — no AJAX/JSON involved.
import "../../../../stylesheets/payment_methods/payu";

export const showPayuCardCaptureModal = (payuId) => {
  document.getElementById("payu_card_capture_payu_id").value = payuId || "";
  $("#loader").hide();
  $("#payu-card-capture-loading").addClass("d-none").removeClass("d-flex");
  $("#payu-card-capture-submit").prop("disabled", false);
  $("#payu-card-capture-modal").modal("show");
};

const handleCardCaptureSubmit = () => {
  $("#payu-card-capture-loading").addClass("d-flex").removeClass("d-none");
  $("#payu-card-capture-submit").prop("disabled", true);
};

$(document).on("submit", "#payu-card-capture-form", handleCardCaptureSubmit);
